import {
  DeleteApiSpoSportProductNatureBody,
  PatchApiSpoSportProductNatureStatusBody,
  PostApiSpoProductNatureFullBody,
  PostApiSpoProductNaturesArchitectureTableBody,
  PostApiSpoProductNaturesBody,
  PostApiSpoProductNaturesReferentialBody,
  PostApiSpoSportProductNaturesBody,
  PostApiSpoSportProductNatureSettingsBody,
  SpoAddSportNatureResponse,
  SpoArchitectureNaturesTableResponse,
  SpoNatureFullResponse,
  SpoPatchSportNatureStatusResponse,
  SpoProductNaturesReferentialResponse,
  SpoProductNaturesResponse,
  SpoSetProductNatureSettingsResponse,
} from '@spo/types';
import { apiBff } from '.';

export const getProductNatures = async (
  postApiSpoProductNaturesBody: PostApiSpoProductNaturesBody,
): Promise<SpoProductNaturesResponse> => {
  return apiBff.callBFF(
    'POST',
    'spo/product_natures',
    postApiSpoProductNaturesBody,
  );
};

export const getProductNaturesReferentialByIds = async (
  postApiSpoProductNaturesReferentialBody: PostApiSpoProductNaturesReferentialBody,
): Promise<SpoProductNaturesReferentialResponse> => {
  return apiBff.callBFF(
    'POST',
    'spo/product_natures_referential',
    postApiSpoProductNaturesReferentialBody,
  );
};

export const getNaturesArchitectureTable = async (
  PostApiSpoProductNaturesArchitectureTableBody: PostApiSpoProductNaturesArchitectureTableBody,
): Promise<SpoArchitectureNaturesTableResponse> => {
  return apiBff.callBFF(
    'POST',
    'spo/product_natures_architecture_table',
    PostApiSpoProductNaturesArchitectureTableBody,
  );
};

export const getFullProductNature = async (
  postApiSpoProductNatureFullBody: PostApiSpoProductNatureFullBody,
): Promise<SpoNatureFullResponse> => {
  return apiBff.callBFF<SpoNatureFullResponse>(
    'POST',
    'spo/product_nature_full',
    postApiSpoProductNatureFullBody,
  );
};

export const addProductNatures = async (
  postApiSpoSportProductNaturesBody: PostApiSpoSportProductNaturesBody,
): Promise<SpoAddSportNatureResponse> => {
  return apiBff.callBFF(
    'POST',
    'spo/sport/product_natures',
    postApiSpoSportProductNaturesBody,
  );
};

export const deleteProductNature = async <T>(
  deleteApiSpoSportProductNatureBody: DeleteApiSpoSportProductNatureBody,
): Promise<T> => {
  return apiBff.callBFF<T>(
    'DELETE',
    'spo/sport/product_nature',
    deleteApiSpoSportProductNatureBody,
  );
};

export const patchProductNature = async (
  patchApiSpoSportProductNatureStatusBody: PatchApiSpoSportProductNatureStatusBody,
): Promise<SpoPatchSportNatureStatusResponse> => {
  return apiBff.callBFF(
    'PATCH',
    'spo/sport/product_nature/status',
    patchApiSpoSportProductNatureStatusBody,
  );
};

export const setProductNatureSettings = async (
  postApiSpoSportProductNatureSettingsBody: PostApiSpoSportProductNatureSettingsBody,
): Promise<SpoSetProductNatureSettingsResponse> => {
  return apiBff.callBFF(
    'POST',
    'spo/sport/product_nature/settings',
    postApiSpoSportProductNatureSettingsBody,
  );
};
